// extracted by mini-css-extract-plugin
export default {"slider":"ProductSlider-module-slider-2_4"};